import React, { useEffect, useRef } from 'react';

import FieldGroup from './FieldGroup';
import PasswordField from './PasswordField';
import messages from './PasswordContainer.messages';

import { useIntl } from 'react-intl';
import { usePrevious } from '../utilities/hooks';

export type PasswordProps = {
  isHidden?: boolean;
  fieldError?: string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  value: string | number | undefined;
  className?: string;
  isRequired?: boolean;
};

const PasswordContainer = ({
  className,
  fieldError,
  isHidden,
  onChange,
  value,
  isRequired = false,
}: PasswordProps) => {
  const { formatMessage } = useIntl();

  const inputRef = useRef<HTMLInputElement>(null);
  const wasHidden = usePrevious(isHidden);

  useEffect(() => {
    if (!isHidden && wasHidden) {
      inputRef.current?.focus();
    }
  }, [isHidden, wasHidden]);

  const fieldErrorNode = fieldError && (
    <span
      id="password-error"
      data-testid="password-error-idf-testid" // used in pollinators
    >
      {fieldError}
    </span>
  );

  return (
    <FieldGroup isHidden={isHidden} className={className}>
      <PasswordField
        id="password"
        testId="password" // used in pollinators
        name="password"
        autoComplete="current-password"
        placeholder={formatMessage(messages.passwordPlaceholder)}
        label={formatMessage(messages.passwordLabel)}
        autoFocus={!isHidden}
        onChange={onChange}
        isInvalid={!!fieldError}
        invalidMessage={fieldErrorNode}
        value={value}
        ref={inputRef}
        isRequired={isRequired}
      />
    </FieldGroup>
  );
};
export default PasswordContainer;
